import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';

import { TabViewState } from './tab-view-state.store';
import { mutations } from './tab-view-mutations.store';
import { actions } from './tab-view-actions.store';
import { ITabViewState } from './tab-view-types.store';
import { getters } from './tab-view-getters.store';

export class TabViewModule<RootState> implements Module<ITabViewState, RootState>{
  namespaced: boolean;
  state: ITabViewState;
  getters: GetterTree<ITabViewState, RootState>;
  actions: ActionTree<ITabViewState, RootState>;
  mutations: MutationTree<ITabViewState>;
 
  constructor() {
    this.namespaced = true;
    this.state = new TabViewState();
    this.mutations = mutations;
    this.actions = actions;
    this.getters = getters;
  }
}